module.exports = __webpack_public_path__ + "static/lframe-kiwibank-personal-loans-ea923e05040ad9315acc4252333d8a48.webp";